"use strict";

import {findIn, closest, on} from "../libs/@elements/dom-utils";
import {onFind} from "../libs/@elements/init-modules-in-scope";

export function init () {

    onFind('.js-link-with-input__link', function (item) {
        on('click', function(event) {
            let parent = closest('.js-link-with-input', this);
            let input = findIn('.js-link-with-input__input', parent);
            let inputValue = item.getAttribute('data-value');
            input.value = inputValue;
        }, item);
    });

}